import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import Title from "designs/v1/components/Title";
import Button from "designs/v1/components/Button";
import BootstrapModal from "designs/v1/pages/ModifyKyc/components/BootstrapModal";
import { getApiUrl } from "utils";
import {
  getRequestTypes,
  getRequestTypeDocs,
  getPhoneReviewApi,
  getAddressReviewApi,
  getBankReviewApi,
  getNomineeReviewApi,
  getIncomeReviewApi,
  getSegmentReviewApi,
  submitMultipleReviewApi,
  multipleRequestForEsign,
} from "designs/v1/pages/ModifyKyc/services";

const MobileModificationReview = ({
  stageScreen,
  setStageScreen,
  setStep,
  isLoading,
  setIsLoading,
}) => {
  const history = useHistory();
  const [reviewData, setReviewData] = useState([]);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const docs_list = getRequestTypeDocs() || [];
    console.log("docs_list", docs_list);
    const promises = [];
    const result = [];
    docs_list.forEach((element) => {
      const request_type = element.split("-")[0];
      const doc_name = element;

      if (request_type === "Mobile Modification") {
        promises.push(
          getPhoneReviewApi({ request_type, doc_name })
            .then((resp) => {
              result.push(resp.data?.data);
            })
            .catch((error) => {
              console.log("err", error);
            })
        );
      }

      if (request_type === "Email Modification") {
        promises.push(
          getPhoneReviewApi({ request_type, doc_name })
            .then((resp) => {
              result.push(resp.data?.data);
            })
            .catch((error) => {
              console.log("err", error);
            })
        );
      }

      if (request_type === "Address Modification") {
        promises.push(
          getAddressReviewApi({
            request_type,
            document_name: doc_name,
            address_type: localStorage.getItem("AddressRequestType"),
          })
            .then((resp) => {
              result.push(resp.data?.data);
            })
            .catch((error) => {
              console.log("err", error);
            })
        );
      }

      if (request_type === "Bank Modification") {
        promises.push(
          getBankReviewApi({
            request_type,
            doc_name,
            bank_modification_type: localStorage.getItem("BankRequestType"),
          })
            .then((resp) => {
              result.push(resp.data?.data);
            })
            .catch((error) => {
              console.log("err", error);
            })
        );
      }

      if (request_type === "Nominee Modification") {
        promises.push(
          getNomineeReviewApi({ request_type, doc_name })
            .then((resp) => {
              result.push(resp.data?.data);
            })
            .catch((error) => {
              console.log("err", error);
            })
        );
      }

      if (request_type === "Income Proof Modification") {
        promises.push(
          getIncomeReviewApi({ request_type, doc_name })
            .then((resp) => {
              result.push(resp.data?.data);
            })
            .catch((error) => {
              console.log("err", error);
            })
        );
      }

      if (request_type === "Segment Modification") {
        promises.push(
          getSegmentReviewApi({ request_type, doc_name })
            .then((resp) => {
              result.push(resp.data?.data);
            })
            .catch((error) => {
              console.log("err", error);
            })
        );
      }
    });

    Promise.all(promises).then(() => {
      setReviewData(result);
    });
  }, []);

  const handleShowHideModal = () => {
    setShowModal((bool) => !bool);
  };

  const getNewRequestTypes = () => {
    let requestTypes = getRequestTypes() || [];
    if (requestTypes.includes("MobileEmailModifications")) {
      const filter = (requestTypes = requestTypes.filter(
        (type) => type !== "MobileEmailModifications"
      ));
      requestTypes = ["Mobile Modification", "Email Modification", ...filter];
    }
    return requestTypes;
  };

  const handleSubmit = async () => {
    const payload = {
      request_type: getNewRequestTypes(),
      document_name: getRequestTypeDocs(),
    };
    const kraEsign = {
      request_type: getNewRequestTypes()?.filter(
        (item) =>
          item.startsWith("Mobile") ||
          item.startsWith("Email") ||
          item.startsWith("Address")
      ),
      document_name: getRequestTypeDocs()?.filter(
        (item) =>
          item.startsWith("Mobile") ||
          item.startsWith("Email") ||
          item.startsWith("Address")
      ),
    };
    const nonKraEsign = {
      request_type: getNewRequestTypes()?.filter(
        (item) =>
          !item.startsWith("Mobile") &&
          !item.startsWith("Email") &&
          !item.startsWith("Address")
      ),
      document_name: getRequestTypeDocs()?.filter(
        (item) =>
          !item.startsWith("Mobile") &&
          !item.startsWith("Email") &&
          !item.startsWith("Address")
      ),
    };
    console.log("kraEsign", kraEsign);
    console.log("nonKraEsign", nonKraEsign);
    console.log("payload", payload);
    setShowModal(false);
    setIsLoading(true);
    try {
      const resp = await submitMultipleReviewApi(payload);
      console.log("resp", resp);
      try {
        if (kraEsign?.request_type?.length > 0) {
          const kraResp = await multipleRequestForEsign(kraEsign);
          if (kraResp.data.message?.status_code !== 200) {
            setIsLoading(false);
            return toast.error(
              resp.esignResp.message?.message ||
                "Internal server error!"
            );
          }
        }
        if (nonKraEsign?.request_type?.length > 0) {
          const nonKraResp = await multipleRequestForEsign(nonKraEsign);
          if (nonKraResp.data.message?.status_code !== 200) {
            setIsLoading(false);
            return toast.error(
              resp.esignResp.message?.message ||
                "Internal server error!"
            );
          }
        }
        if (resp.data.message?.status_code !== 200) {
          setIsLoading(false);
          return toast.error(
            resp.data.message?.message ||
              "Internal server error!"
          );
        }
        setIsLoading(false);
        toast.success(resp.data.message?.message);
        setStep("ESignature");
      } catch (error) {
        const { data } = error.response || {};
        toast.error(
          data.message?.message || "Internal server error!"
        );
        setIsLoading(false);
      }
    } catch (error) {
      console.log("err", error);
      setIsLoading(false);
      const { data } = error.response;
      toast.error(
        data.message?.message || "Internal server error!"
      );
    }
  };

  const getSegmentList = (review) => {
    const filter = (review?.modification_details || []).filter(
      (y) => y.bse || y.nse || y.mcx || y.msei || y.ncdex
    );
    return filter;
  };

  return (
    <>
      <Title title="Review Details" />
      <div className="row">
        <div className="col-md-12">
          <div className="form-group">
            <div className="mb-2">
              {reviewData.length > 0 &&
                reviewData.map((review, index) => {
                  return (
                    <div key={index}>
                      {index === 0 && (
                        <>
                          <div className="row my-4 my-3">
                            <h6 className="text-bold m-0">User Details</h6>
                            <div className="row mt-1">
                              <div className="col-sm">Full Name</div>
                              <div className="col-sm">
                                {review.current_user_details?.full_name ||
                                  review.active_user_details?.full_name}
                              </div>
                            </div>
                            <div className="row mt-1">
                              <div className="col-sm">Mobile Number</div>
                              <div className="col-sm">
                                {review.current_user_details?.active_mobile?.slice(
                                  2
                                ) ||
                                  review.current_user_details?.mobile?.slice(
                                    2
                                  ) ||
                                  review.active_user_details?.mobile?.slice(2)}
                              </div>
                            </div>
                            <div className="row mt-1">
                              <div className="col-sm">Email Address</div>
                              <div className="col-sm">
                                {review.current_user_details?.active_email ||
                                  review.current_user_details?.email ||
                                  review.active_user_details?.email}
                              </div>
                            </div>
                            <div className="row mt-1">
                              <div className="col-sm">PAN Number</div>
                              <div className="col-sm">
                                {review.current_user_details?.pan_number ||
                                  review.active_user_details?.pan_number}
                              </div>
                            </div>
                          </div>
                          <div className="row my-4">
                            <hr />
                          </div>
                        </>
                      )}
                      <div className="row my-4 my-3">
                        <div className="row">
                          <h6 className="col-sm text-bold m-0">Request Type</h6>
                          <div className="col-sm">{review?.request_type}</div>
                        </div>
                      </div>
                      {/* <div className="row my-4 my-3">
                        <div className="row">
                          <h6 className="col-sm text-bold m-0">
                            Reason Details
                          </h6>
                          <div className="col-sm">
                            {review.reason_details?.user_input_reason}
                          </div>
                        </div>
                      </div> */}
                      {review?.request_type === "Mobile Modification" && (
                        <div className="row my-4 my-3">
                          <h6 className="text-bold m-0">User Details</h6>
                          <div className="row my-1">
                            <div className="col-sm">New Mobile Number</div>
                            <div className="col-sm">
                              {review.modification_details?.modification_phone?.slice(
                                2
                              )}
                            </div>
                          </div>
                        </div>
                      )}
                      {review?.request_type === "Email Modification" && (
                        <div className="row my-4 my-3">
                          <h6 className="text-bold m-0">User Details</h6>
                          <div className="row my-1">
                            <div className="col-sm">New Email Address</div>
                            <div className="col-sm">
                              {review.modification_details?.modification_email}
                            </div>
                          </div>
                        </div>
                      )}
                      {review?.request_type === "Address Modification" && (
                        <>
                          <div className="row my-4 my-3">
                            <h6 className="text-bold m-0">
                              New Address Details
                            </h6>
                          </div>
                          {review.modification_details?.permanent_address
                            ?.address_line1 && (
                            <div className="row my-4 my-3">
                              <h6 className="text-bold m-0">
                                Permanent Address Details
                              </h6>
                              <div className="row mt-1">
                                <div className="col-sm">Address</div>
                                <div className="col-sm">
                                  {
                                    review.modification_details
                                      ?.permanent_address?.address_line1
                                  }
                                </div>
                              </div>
                              <div className="row mt-1">
                                <div className="col-sm">Pincode</div>
                                <div className="col-sm">
                                  {
                                    review.modification_details
                                      ?.permanent_address?.pincode
                                  }
                                </div>
                              </div>
                              <div className="row mt-1">
                                <div className="col-sm">City</div>
                                <div className="col-sm">
                                  {
                                    review.modification_details
                                      ?.permanent_address?.city
                                  }
                                </div>
                              </div>
                              <div className="row mt-1">
                                <div className="col-sm">State</div>
                                <div className="col-sm">
                                  {
                                    review.modification_details
                                      ?.permanent_address?.state
                                  }
                                </div>
                              </div>
                              <div className="row mt-1">
                                <div className="col-sm">Country</div>
                                <div className="col-sm">
                                  {
                                    review.modification_details
                                      ?.permanent_address?.country
                                  }
                                </div>
                              </div>
                            </div>
                          )}
                          {review.modification_details?.communication_address
                            ?.address_line1 && (
                            <div className="row my-4 my-3">
                              <h6 className="text-bold m-0">
                                Correspondence Address Details
                              </h6>
                              <div className="row mt-1">
                                <div className="col-sm">Address</div>
                                <div className="col-sm">
                                  {
                                    review.modification_details
                                      ?.communication_address?.address_line1
                                  }
                                </div>
                              </div>
                              <div className="row mt-1">
                                <div className="col-sm">City</div>
                                <div className="col-sm">
                                  {
                                    review.modification_details
                                      ?.communication_address?.city
                                  }
                                </div>
                              </div>
                              <div className="row mt-1">
                                <div className="col-sm">State</div>
                                <div className="col-sm">
                                  {
                                    review.modification_details
                                      ?.communication_address?.state
                                  }
                                </div>
                              </div>
                              <div className="row mt-1">
                                <div className="col-sm">Pincode</div>
                                <div className="col-sm">
                                  {
                                    review.modification_details
                                      ?.communication_address?.pincode
                                  }
                                </div>
                              </div>
                              <div className="row mt-1">
                                <div className="col-sm">Country</div>
                                <div className="col-sm">
                                  {
                                    review.modification_details
                                      ?.communication_address?.country
                                  }
                                </div>
                              </div>
                            </div>
                          )}
                        </>
                      )}
                      {review?.request_type === "Bank Modification" && (
                        <div className="row my-4 my-3">
                          <h6 className="text-bold m-0">New Bank Details</h6>
                          {!review?.modification_details?.length ? (
                            <>
                              <div className="row my-1">
                                <div className="col-sm">Name</div>
                                <div className="col-sm">
                                  {review.modification_details?.registered_name}
                                </div>
                              </div>
                              <div className="row my-1">
                                <div className="col-sm">Account Type</div>
                                <div className="col-sm">
                                  {review.modification_details?.account_type}
                                </div>
                              </div>
                              <div className="row my-1">
                                <div className="col-sm">Account Number</div>
                                <div className="col-sm">
                                  {
                                    review.modification_details
                                      ?.verified_account_number
                                  }
                                </div>
                              </div>
                              <div className="row my-1">
                                <div className="col-sm">Bank Name</div>
                                <div className="col-sm">
                                  {
                                    review.modification_details
                                      ?.verified_bank_name
                                  }
                                </div>
                              </div>
                              <div className="row my-1">
                                <div className="col-sm">Branch Name</div>
                                <div className="col-sm">
                                  {review.modification_details?.verified_branch}
                                </div>
                              </div>
                              <div className="row my-1">
                                <div className="col-sm">IFSC code</div>
                                <div className="col-sm">
                                  {review.modification_details?.verified_ifsc}
                                </div>
                              </div>
                              <div className="row my-1">
                                <div className="col-sm">Primary Bank</div>
                                <div className="col-sm">
                                  {review.modification_details
                                    ?.is_primary_bank_account === 1
                                    ? "Yes"
                                    : "No"}
                                </div>
                              </div>
                              {review.modification_details
                                ?.upload_cancelled_cheque && (
                                <div className="row my-1">
                                  <div className="col-sm">Cheque Image</div>
                                  <div className="col-sm">
                                    <img
                                      src={`${getApiUrl()}/${
                                        review.modification_details
                                          ?.upload_cancelled_cheque
                                      }`}
                                      width="200"
                                      alt=""
                                    />
                                  </div>
                                </div>
                              )}
                            </>
                          ) : (
                            <>
                              {review?.modification_details?.length > 0 && (
                                <div className="row mt-2">
                                  <table className="table mx-2">
                                    <thead>
                                      <tr>
                                        <th scope="col">Account Type</th>
                                        <th scope="col">Account Number</th>
                                        <th scope="col">Bank Name</th>
                                        <th scope="col">Branch</th>
                                        <th scope="col">IFSC Code</th>
                                        {/* <th scope="col">MICR Code</th> */}
                                        <th scope="col">Primary Bank</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {review.modification_details
                                        .filter(
                                          (item) =>
                                            item.verified_bank_account === 1
                                        )
                                        .map((item, idx) => {
                                          return (
                                            <tr key={idx}>
                                              <td>
                                                {item.account_type || "-"}
                                              </td>
                                              <td>
                                                {item.verified_account_number}
                                              </td>
                                              <td>{item.verified_bank_name}</td>
                                              <td>{item.verified_branch}</td>
                                              <td>{item.verified_ifsc}</td>
                                              {/* <td>{item.verified_micr_code || "-"}</td> */}
                                              <td>
                                                {item.is_primary_bank_account ===
                                                1
                                                  ? "Yes"
                                                  : "No"}
                                              </td>
                                            </tr>
                                          );
                                        })}
                                    </tbody>
                                  </table>
                                </div>
                              )}
                            </>
                          )}
                        </div>
                      )}
                      {review?.request_type === "Nominee Modification" && (
                        <div className="row my-4 my-3">
                          {review?.modification_details?.length > 0 ? (
                            <div className="row">
                              <h6 className="text-bold m-0">
                                New Nominee Details
                              </h6>
                              {/* <div className="row">
                                <h6 className="col-sm">New Nominee Details</h6>
                              </div> */}
                              <table className="table mx-2 mt-2">
                                <thead>
                                  <tr>
                                    <th scope="col">Name</th>
                                    <th scope="col">Mobile Number</th>
                                    <th scope="col">Date of birth</th>
                                    <th scope="col">Relationship</th>
                                    <th scope="col">Share(%)</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {review.modification_details.map((item) => {
                                    return (
                                      <tr key={item.idx}>
                                        <td>{item.nominee_name}</td>
                                        <td>{item.mobile}</td>
                                        <td>
                                          {item.nominee_dob
                                            ?.split("-")
                                            .reverse()
                                            .join("-")}
                                        </td>
                                        <td>
                                          {item.relationship_with_applicant}
                                        </td>
                                        <td>{item.share_of__nominee}</td>
                                      </tr>
                                    );
                                  })}
                                </tbody>
                              </table>
                            </div>
                          ) : (
                            <h6 className="text-bold m-0">
                              No Nominee Details Found...
                            </h6>
                          )}
                        </div>
                      )}
                      {review?.request_type === "Income Proof Modification" &&
                        review.modification_details?.length && (
                          <>
                            <div className="row my-4 my-3">
                              <h6 className="text-bold m-0">
                                New Income Proof Details
                              </h6>
                              <div className="row my-1">
                                <div className="col-sm">Proof Type</div>
                                <div className="col-sm">
                                  {review.modification_details[0]?.icp_type}
                                </div>
                              </div>
                              <div className="row mt-2">
                                <div className="col-sm">Proof File</div>
                                {review.modification_details[0]?.icp && (
                                  <a
                                    className="col-sm"
                                    target="_blank"
                                    href={
                                      getApiUrl() +
                                      review.modification_details[0].icp
                                    }
                                    rel="noreferrer noreferrer"
                                  >
                                    Download here
                                  </a>
                                )}
                              </div>
                            </div>
                          </>
                        )}
                      {review?.request_type === "Segment Modification" && (
                        <>
                          <div className="row my-4 my-3">
                            <h6 className="text-bold m-0">
                              New Segment Details
                            </h6>
                            <div className="row my-1">
                              <table className="table mx-2">
                                <thead>
                                  <tr>
                                    <th scope="col">Segment</th>
                                    {getSegmentList(review).some(
                                      (y) => y.bse
                                    ) && <th>BSE</th>}
                                    {getSegmentList(review).some(
                                      (y) => y.nse
                                    ) && <th>NSE</th>}
                                    {getSegmentList(review).some(
                                      (y) => y.mcx
                                    ) && <th>MCX</th>}
                                    {getSegmentList(review).some(
                                      (y) => y.msei
                                    ) && <th>MSEI</th>}
                                    {getSegmentList(review).some(
                                      (y) => y.ncdex
                                    ) && <th>NCDEX</th>}
                                  </tr>
                                </thead>
                                <tbody>
                                  {getSegmentList(review).map(
                                    (result, index) => {
                                      return (
                                        <tr key={index}>
                                          <td>{result.segment}</td>
                                          {getSegmentList(review).some(
                                            (y) => y.bse
                                          ) && (
                                            <td>
                                              <input
                                                type="checkbox"
                                                checked={result.bse}
                                                disabled
                                              />
                                            </td>
                                          )}
                                          {getSegmentList(review).some(
                                            (y) => y.nse
                                          ) && (
                                            <td>
                                              <input
                                                type="checkbox"
                                                checked={result.nse}
                                                disabled
                                              />
                                            </td>
                                          )}
                                          {getSegmentList(review).some(
                                            (y) => y.mcx
                                          ) && (
                                            <td>
                                              <input
                                                type="checkbox"
                                                checked={result.mcx}
                                                disabled
                                              />
                                            </td>
                                          )}
                                          {getSegmentList(review).some(
                                            (y) => y.msei
                                          ) && (
                                            <td>
                                              <input
                                                type="checkbox"
                                                checked={result.msei}
                                                disabled
                                              />
                                            </td>
                                          )}
                                          {getSegmentList(review).some(
                                            (y) => y.ncdex
                                          ) && (
                                            <td>
                                              <input
                                                type="checkbox"
                                                checked={result.ncdex}
                                                disabled
                                              />
                                            </td>
                                          )}
                                        </tr>
                                      );
                                    }
                                  )}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </>
                      )}
                      <div className="row my-4">
                        <hr />
                      </div>
                      {reviewData.length - 1 === index && (
                        <div className="form-group my-4 my-3">
                          <Button
                            title="Submit"
                            type="button"
                            handleClick={handleShowHideModal}
                          />
                        </div>
                      )}
                    </div>
                  );
                })}
            </div>
          </div>
        </div>
      </div>
      <BootstrapModal
        show={showModal}
        title="Modify Your Details"
        content={`Are you sure you want to modify these ${getNewRequestTypes().join(
          ", "
        )}?`}
        loading={isLoading}
        handleClose={handleShowHideModal}
        handleSubmit={handleSubmit}
      />
    </>
  );
};

export default MobileModificationReview;
